import { defineMessages } from 'react-intl';

export default defineMessages({
    nameOfBusiness: {
        id: 'ml.quoteandbind.pupbusinessactivities.nameOfBusiness',
        defaultMessage: 'Name of business'
    },
    coverageType: {
        id: 'ml.quoteandbind.pupbusinessactivities.coverageType',
        defaultMessage: 'Coverage Type'
    }
});
